const errorMap = new Map();
errorMap.set(
  'booking-in-progress',
  'Für diesen Termin wird gerade eine Buchung durchgeführt. Bitte versuche es in ein paar Sekunden erneut.',
);
errorMap.set('mobile-required', 'Mobilnummer ist erforderlich');
errorMap.set('mobile-invalid', 'Mobilnummer ist ungültig');
errorMap.set('only-bookable-by-group', 'Buchung nicht möglich');

export function getErrorMessage(errorId) {
  const msg = errorMap.get(errorId);
  return msg ? msg : 'Es ist ein Fehler aufgetreten.';
}

export function extractErrorIds(error) {
  if (!error) {
    return ['unknown-error'];
  }

  if (!(error?.graphQLErrors?.length > 0)) {
    return ['unknown-error'];
  }

  if (error.graphQLErrors[0].message) {
    const errorId = error.graphQLErrors[0].message;
    return [errorId];
  }

  return ['unknown-error'];
}

export function setFormikErrorMessages(actions, error) {
  console.log(JSON.stringify(error, 0, 2));

  let errorCodes = [];

  if (error && error.graphQLErrors && error.graphQLErrors.length > 0) {
    if (error.graphQLErrors[0].message === 'validation-error') {
      const errors = error.graphQLErrors[0].extensions.error.inner;
      errors.forEach(error => {
        // actions.setFieldError(error.path, error.type);
        actions.setFieldError(error.path, generateErrorMessage(error));
      });
    }
    if (error.graphQLErrors[0].message === 'not-enough-places') {
      actions.setFieldError(
        'numPlaces',
        'Anzahl Plätze muss höher sein als Summe der Buchungen',
      );
    }
    if (error.graphQLErrors[0].message === 'has-waitlist-bookings') {
      actions.setFieldError(
        'canBePurchased',
        'Termin hat Wartelistenbuchungen',
      );
      actions.setFieldError('hasWaitlist', 'Termin hat Wartelistenbuchungen');
    }
    if (error.graphQLErrors[0].message === 'num-max-waitlist-too-small') {
      actions.setFieldError(
        'numMaxWaitlist',
        'Termin hat bereits mehr Wartelistenbuchungen',
      );
    }
    if (error.graphQLErrors[0].message.startsWith('too-many-events')) {
      const maxEvents = error.graphQLErrors[0].message.split(':')[1];
      let msg = `Über die Funktion 'Kurs anlegen' sowie 'Termine hinzufügen' können `;
      msg += `pro Speichervorgang maximal ${maxEvents} Termine gleichzeitig angelegt werden.`;
      actions.setFieldError('seriesParams.lastDate', msg);
    }
    if (error.graphQLErrors[0].message.startsWith('already-registered')) {
      errorCodes.push('already-registered');
    }
    if (error.graphQLErrors[0].message.startsWith('trainer-not-found')) {
      actions.setFieldError(
        'trainer',
        'Ausgewählter Trainer konnte nicht gefunden werden',
      );
    }
    if (error.graphQLErrors[0].message.startsWith('bookable-usergroups-required')) {
      actions.setFieldError(
        'bookableUsergroups',
        'Es muss mindestens 1 gültige Gruppe ausgewählt werden',
      );
    }
    if (error.graphQLErrors[0].message.startsWith('unknown-email')) {
      actions.setFieldError(
        'email',
        'Unbekannte E-Mail Adresse',
      );
    }
    if (error.graphQLErrors[0].message.startsWith('invalid-password')) {
      actions.setFieldError(
        'password',
        'Ungültiges Passwort',
      );
    }
    if (error.graphQLErrors[0].message.startsWith('email-not-confirmed')) {
      actions.setFieldError(
        'email',
        'Diese E-Mail Adresse wurde noch nicht bestätigt',
      );
      errorCodes.push('email-not-confirmed');
    }
    if (error.graphQLErrors[0].message.startsWith('activation-token-not-found')) {
      actions.setFieldError(
        'password',
        'Ungültiger Aktivierungslink',
      );
      errorCodes.push('activation-token-not-found');
    }
    // console.log(errors);
  } else {
    // TODO handle unknown error
  }
  return errorCodes;
}

function generateErrorMessage(error) {
  const fieldName = getFieldLiteral(error.path);
  if (error.type === 'optionality') {
    return `${fieldName} ist erforderlich`;
  } else if (error.type === 'required') {
    return `${fieldName} ist erforderlich`;
  } else if (error.type === 'min') {
    if (error.path === 'endTime') {
      return `${fieldName} muss größer als ${getFieldLiteral(
        'startTime',
      )} sein`;
    } else if (pathIsNumber(error.path)) {
      return `${fieldName} muss mindestens ${error.params.min} sein`;
    } else {
      return `${fieldName} muss mindestens ${error.params.min} Zeichen lang sein`;
    }
  } else if (error.type === 'max') {
    if (pathIsNumber(error.path)) {
      return `${fieldName} darf maximal ${error.params.max} sein`;
    }
    return `${fieldName} darf maximal ${error.params.max} Zeichen lang sein`;
  } else if (error.type === 'url') {
    return `${fieldName} muss eine gültige URL sein`;
  } else if (error.type === 'email') {
    return `${fieldName} muss eine gültige E-Mail sein`;
  } else if (error.type === 'only-canBePurchased-or-hasWaitlist-allowed') {
    return `Wartelistenfunktion und Kauf nicht möglich`;
  } else if (error.message === 'agb-not-accepted') {
    return 'AGBs müssen akzeptiert sein';
  } else if (error.message === 'email-already-in-use') {
    return 'Diese E-Mail Adresse ist bereits in Benutzung';
  } else if (error.message === 'mandant-name-exists') {
    return 'Eine Organisation mit diesem Namen existiert bereits';
  } else if (error.message === 'mandant-name-invalid') {
    return 'Ungültiger Organisationsname';
  } else if (error.message === 'invalid-phone-number') {
    return 'Mobilnummer ungültig';
  } else if (error.message === 'password-confirmation-mismatch') {
    return 'Passwort Wiederholung stimmt nicht überein';
  } else if (error.message === 'unknown-email') {
    return 'Unbekannte E-Mail Adresse';
  } else {
    return 'Unbekannter Fehler';
  }
}

function pathIsNumber(errorPath) {
  const numberPaths = new Set();
  numberPaths.add('amountGross');
  numberPaths.add('amountNet');
  numberPaths.add('credits');
  numberPaths.add('dueDays');
  numberPaths.add('invoiceStartNumber');
  numberPaths.add('minRegistrations');
  numberPaths.add('numPlaces');
  numberPaths.add('quantity');
  numberPaths.add('numMaxWaitlist');
  numberPaths.add('minRegDeadlineMinutes');
  numberPaths.add('purchaseAmountNet');
  numberPaths.add('purchaseTaxPercent');
  numberPaths.add('taxPercent');
  numberPaths.add('tlcDaysBeforeDiscarded');
  return numberPaths.has(errorPath);
}

function getFieldLiteral(fieldName) {
  if (fieldName && fieldName.startsWith('links')) {
    if (fieldName.endsWith('label')) {
      return 'Name';
    } else {
      return 'Link';
    }
  }
  const m = new Map();
  m.set('agbAccepted', 'AGB');
  m.set('amountNet', 'Betrag Netto');
  m.set('amountGross', 'Betrag Brutto');
  m.set('bankBic', 'BIC');
  m.set('bankName', 'Bankname');
  m.set('bankReceiverName', 'Kontoinhaber');
  m.set('city', 'Ort');
  m.set('"canBePurchased"', 'Kauf');
  m.set('companyName', 'Firmenname');
  m.set('courseName', 'Kursname');
  m.set('country', 'Land');
  m.set('credits', 'Punkte');
  m.set('description', 'Beschreibung');
  m.set('dueDays', 'Fälligkeit');
  m.set('email', 'E-Mail');
  m.set('endTime', 'Endzeit');
  m.set('firstName', 'Vorname');
  m.set('bankIban', 'IBAN');
  m.set('invoiceStartNumber', 'Rechnungsstartnummer');
  m.set('lastName', 'Nachname');
  m.set('mandantCompanyName', 'Firmenname');
  m.set('mandantName', 'Organisationsname');
  m.set('mandantNameOnBill', 'Name auf Rechnung');
  m.set('mandantStreet', 'Straße');
  m.set('mandantStreetNr', 'Hausnr.');
  m.set('mandantZipCode', 'PLZ');
  m.set('mandantCity', 'Ort');
  m.set('mandantPhone', 'Tel.');
  m.set('mandantWebsite', 'Website');
  m.set('mandantVatId', 'Umsatzsteuer-IdNr.');
  m.set('mandantTaxNumber', 'Steuernummer');
  m.set('message', 'Nachricht');
  m.set('name', 'Name');
  m.set('nameOnBill', 'Name auf Rechnung');
  m.set('minRegDeadlineMinutes', 'Prüffrist');
  m.set('minRegistrations', 'Mindest Teilnehmeranzahl');
  m.set('mobile', 'Mobilnummer');
  m.set('notice', 'Rechnungsbemerkung');
  m.set('numPlaces', 'Anzahl Plätze');
  m.set('numMaxWaitlist', 'Anzahl Wartelistenplätze');
  m.set('password', 'Passwort');
  m.set('passwordConfirmation', 'Passwort Wiederholung');
  m.set('phone', 'Tel.');
  m.set('purchaseAmountNet', 'Betrag Netto');
  m.set('purchaseTaxPercent', 'MwSt. %');
  m.set('quantity', 'Anzahl');
  m.set('seriesParams.weekDays', 'Wochentag');
  m.set('startTime', 'Startzeit');
  m.set('street', 'Straße');
  m.set('streetNr', 'Hausnr.');
  m.set('taxNumber', 'Steuernummer');
  m.set('taxPercent', 'MwSt %');
  m.set('tlcDaysBeforeDiscarded', 'Anzahl Tage');
  m.set('vatId', 'Umsatzsteuer-ID');
  m.set('website', 'Website');
  m.set('zipCode', 'PLZ');
  return m.get(fieldName);
}
